import { ReactComponent as HtmlLogo } from './html-3.svg'
import { ReactComponent as ImagesLogo } from './gallery.svg'
import { ReactComponent as FontsLogo } from './fonts.svg'
import { ReactComponent as JSONLogo } from '../../../assets/svg/jsonIcon.svg'
export const folders = [
    {
        id: 1,
        label: "Images",
        fileCount: 10,
        Icon: ImagesLogo,
        path: "images"
        
    },
    {
        id: 2,
        label: "CSS",
        fileCount: 10,
        Icon: HtmlLogo,
        path: "css"
        
    },
    {
        id: 3,
        label: "Fonts",
        fileCount: 1,
        Icon: FontsLogo,
        path: "fonts"
    },
    {
        id: 4,
        label: "JSON",
        fileCount: 10,
        Icon: JSONLogo,
        path: "json"
    }
] 